export const PriceFormatLocale = 'nl-BE';
